export function useFetchDependencies () {
  const { isPreviewMode } = useUmbracoPreviewMode();
  const nuxtApp = useNuxtApp();

  let route;
  if ( import.meta.server ) {
    route = nuxtApp.ssrContext?.url ?? "_unknown_";
  } else {
    route = window.location.pathname;
  }

  return {
    cookie: useCookie( "token" ),
    route,
    headerCookies: useRequestHeaders( ["cookie"] ),
    culture: useCurrentCulture(),
    cultureList: useCultureList(),
    apiStore: useApiStore(),
    previewModeApiKey: useUmbracoPreviewModeApiKey(),
    previewMode: ref( isPreviewMode() ),
    debug: useDebugMode(),
  };
}
